import { Document } from "docx";
import { sectionsBerlin } from "./sectionsBerlin";
import { sectionsBrandenburg } from "./sectionsBrandenburg";

export class EinzelGutachten {
  static async create(user, klausur, schueler, textbausteine, companies, logo) {
    const land = companies.find(
      (c) => c.id === parseInt(klausur.companyId)
    ).land;
    const sections =
      land === "Brandenburg"
        ? sectionsBrandenburg(
            user,
            klausur,
            schueler,
            textbausteine,
            companies,

          )
        : sectionsBerlin(
            user,
            klausur,
            schueler,
            textbausteine,
            companies,

          );
    const document = new Document({
      sections,
    });
    return document;
  }
}
